// A production build references its entry bundle as /static/js/main.<hash>.js, and the
// hash changes whenever the code does. Comparing the running page's hash with the one in
// a fresh index.html says whether a newer version has been deployed. The dev server's
// bundle.js has no hash, so there is nothing to compare there.
const MAIN_BUNDLE = /\/static\/js\/main\.([0-9a-f]+)\.js/;

export function buildIdFromHtml(html) {
  const match = typeof html === 'string' ? html.match(MAIN_BUNDLE) : null;
  return match ? match[1] : null;
}

export function currentBuildId(doc = document) {
  const script = [...doc.scripts].find((s) => MAIN_BUNDLE.test(s.getAttribute('src') || ''));
  return script ? buildIdFromHtml(script.getAttribute('src')) : null;
}

// The query string makes the URL unique, so neither the browser nor Cloudflare (which
// holds index.html for up to a day) can answer from cache.
export async function fetchLatestIndexHtml() {
  const response = await fetch(`/index.html?v=${Date.now()}`, { cache: 'no-store' });
  return response.ok ? response.text() : '';
}

// A page loaded before a deploy asks for route chunks the deploy has since removed.
// webpack names that failure ChunkLoadError; CSS chunks only say so in the message.
export function isChunkLoadError(error) {
  if (!error) return false;
  return (
    error.name === 'ChunkLoadError' || /Loading (CSS )?chunk \S+ failed/.test(error.message || '')
  );
}

const RELOAD_KEY = 'myfvsd.staleChunkReloadAt';
const RELOAD_GAP_MS = 30 * 1000;

// Reloads to pick up the new version, unless the page already did so moments ago: a chunk
// that is still missing after a reload is a real fault, and reloading again would loop.
// Without sessionStorage there is no way to tell, so it does not reload.
export function reloadForStaleChunk({
  storage = window.sessionStorage,
  now = Date.now(),
  reload = () => window.location.reload(),
} = {}) {
  try {
    const last = Number(storage.getItem(RELOAD_KEY)) || 0;
    if (now - last < RELOAD_GAP_MS) return false;
    storage.setItem(RELOAD_KEY, String(now));
  } catch (error) {
    return false;
  }
  reload();
  return true;
}
